import React, { Component } from 'react';
import './testListItem.css';
import { Link } from 'react-router-dom';

class TestListItem extends Component {
  state = {
    load: false
  };

  deleteItem = async name => {
    fetch(window.location.hostname === 'localhost' ? `http://172.21.0.4/public/quizzes/${name}/delete` : `https://ppc.world/quizzes/api/public/quizzes/${name}/delete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        alert('Произошла ошибка, попробуйте еще раз');
      });
  };

  render() {
    return (
      <React.Fragment>
        {this.props.list.map((item, index) => (
          <div className="test-list-item" key={index}>
            <Link
              to={`/${item.slug}`}
              className="test-list-item__title"
              target="_blank"
            >
              {item.name}
            </Link>
            <Link
              to={`/admin/edit/${item.slug}/${item.testType}`}
              className="link test-list-item__link"
            >
              Редактировать
            </Link>
            <Link
              to={`/${item.slug}`}
              className="link test-list-item__link"
              target="_blank"
            >
              Просмотр
            </Link>
            <Link
              to={`/admin/statistic/${item.slug}`}
              className="link test-list-item__link"
            >
              Статистика
            </Link>
            <Link
              to={`/admin/answers/${item.slug}`}
              className="link test-list-item__link"
            >
              Ответы
            </Link>
            <span
              className="link test-list-item__link"
              onClick={this.deleteItem.bind(this, item.slug)}
            >
              Удалить
            </span>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default TestListItem;
